module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"zip":"Zip Code","street":"Street","number":"Number","district":"District","note":"Note","city":"City","state":"State","next":"Next","optional":"Optional"},"pt-BR":{"zip":"CEP","street":"Rua","number":"Número","district":"Bairro","note":"Complemento","city":"Cidade","state":"Estado","next":"Próximo","optional":"Opcional"}}')
  delete Component.options._Ctor
}
